module.exports = __webpack_public_path__ + "img/icon_weather_114.9d909676.svg";